(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.desktopShelf = this.querySelector('[data-shelf-scroll]') ? matchMedia('(min-width: 990px)') : null;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.desktopShelf?.matches && scrollTop > this.headerBounds.bottom && Math.abs(scrollTop - this.currentScrollTop) < 8) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.desktopShelf?.matches && this.header.classList.contains('shopify-section-header-hidden')) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.desktopShelf?.matches && this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden')) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text-slider"] && !Shopify.designMode) return;
  try {
    
new Swiper('.custom-swiper', {
  loop: false,
  autoplay: {
    delay: 12000,
  },
  effect: 'slide',
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: false,
  },
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-modulo"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('woodvibe-modulo')) {
  customElements.define('woodvibe-modulo', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const dataNode = this.querySelector('[data-modulo-data]');
      if (!dataNode) return;
      this.ready = true;
      this.abort = new AbortController();
      this.data = JSON.parse(dataNode.textContent);
      this.t = this.data.text;
      this.colours = this.data.colours;
      this.live = this.dataset.purchase === 'true';
      this.preorderText = this.data.preorder;
      this.preorderItems = [];
      this.mount = null;
      this.mixed = !this.live;
      this.busy = false;
      this.key = this.colours.find(c => c.available)?.key || this.colours[0]?.key;
      const requested = new URL(location.href).searchParams.get('variant');
      const linked = this.colours.find(c => String(c.id) === requested);
      if (linked) this.key = linked.key;
      this.listen(this, 'click', this.click.bind(this));
      this.setupPhotoViewer();
      this.listen(document, 'shopify:block:select', e => {
        if (this.contains(e.target) && e.target.matches('[data-hero-extra]')) {
          const colour = e.target.dataset.heroExtra;
          if (colour !== 'all') this.colour(colour, false);
          this.updateGalleryVisibility();
        }
      });
      this.listen(this, 'input', () => this.refresh());
      this.listen(this, 'change', e => {
        if (e.target.matches('[data-support]')) this.support();
        if (e.target.matches('[data-mount]')) {
          this.mount = e.target.value;
          this.support();
          this.renderMount();
        }
        this.refresh();
      });
      this.listen(this.querySelector('form'), 'submit', this.submit.bind(this));
      this.listen(this.$('.wm-waitlist-shopify'), 'submit', e => this.savePreorder(e));
      this.listen(window, 'pageshow', () => this.resetPreorderSubmission());
      this.listen(this, 'change', e => {
        if (!e.target.matches('[data-preorder-quantity]')) return;
        const item = this.preorderItems.find(x => x.id === e.target.dataset.preorderQuantity);
        const quantity = Number(e.target.value);
        if (!item || !Number.isSafeInteger(quantity) || quantity < 1 || quantity > 99) {
          e.target.value = item?.quantity || 1;
          this.$('[data-preorder-error]').hidden = false;
          this.$('[data-preorder-error]').textContent = this.preorderText.invalid_quantity;
          return;
        }
        item.quantity = quantity;
        this.persistPreorder();
        this.renderPreorder();
      });
      this.listen(document, 'woodvibe:snap-visibility-change', () => this.syncSnap());
      if (!this.live) this.restorePreorder();
      this.setupMedia();
      const demoVideo = this.querySelector('[data-gallery-video] video');
      if (demoVideo) {
        demoVideo.muted = true;
        demoVideo.playsInline = true;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          demoVideo.autoplay = false;
          demoVideo.pause();
        }
      }
      this.colour(this.key, false);
      this.syncSnap();
      this.support();
      this.refresh();
    }

    setupPhotoViewer() {
      const d = this.$('[data-photo-dialog]');
      this.listen(this.$('[data-photo-close]'), 'click', () => d.close());
      this.listen(this.$('[data-photo-prev]'), 'click', () => this.renderPhoto(this.photoIndex - 1));
      this.listen(this.$('[data-photo-next]'), 'click', () => this.renderPhoto(this.photoIndex + 1));
      this.listen(d, 'click', e => { if(e.target === d) d.close(); });
      this.listen(d, 'close', () => this.photoOpener?.focus({preventScroll:true}));
      this.listen(d, 'keydown', e => {
        if(e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
          e.preventDefault(); this.renderPhoto(this.photoIndex + (e.key === 'ArrowLeft' ? -1 : 1));
        }
      });
      this.listen(this, 'keydown', e => {
        const stage = e.target.closest('[data-photo-trigger]');
        if(stage && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); this.openPhoto(stage); }
      });
      this.listen(this, 'click', e => {
        const stage = e.target.closest('[data-photo-trigger]');
        if(stage) this.openPhoto(stage);
      });
      this.preparePhotoTriggers();
    }
    preparePhotoTriggers() {
      this.querySelectorAll('.wm-primary > .wm-stage, .wm-hero-extras figure .wm-stage').forEach(stage => {
        if(stage.querySelector('video')){delete stage.dataset.photoTrigger;stage.removeAttribute('role');stage.removeAttribute('tabindex');stage.removeAttribute('aria-haspopup');stage.removeAttribute('aria-label');return;}
        stage.dataset.photoTrigger = '';
        stage.setAttribute('role', 'button');
        stage.tabIndex = 0;
        stage.setAttribute('aria-haspopup', 'dialog');
        stage.setAttribute('aria-label', this.$('[data-photo-dialog]').getAttribute('aria-label'));
      });
    }
    openPhoto(stage) {
      this.photoStages = Array.from(this.querySelectorAll('[data-photo-trigger]')).filter(x => !x.closest('[hidden]'));
      const primary = this.photoStages.filter(x => x.closest('.wm-primary'));
      const extras = this.photoStages.filter(x => !x.closest('.wm-primary')).sort((a,b) => Number(a.closest('figure').style.order || 0) - Number(b.closest('figure').style.order || 0));
      this.photoStages = [...primary,...extras];
      this.photoOpener = stage;
      this.renderPhoto(this.photoStages.indexOf(stage));
      this.$('[data-photo-dialog]').showModal();
      this.$('[data-photo-close]').focus();
    }
    renderPhoto(index) {
      if(!this.photoStages?.length) return;
      this.photoIndex = (index + this.photoStages.length) % this.photoStages.length;
      const source = this.photoStages[this.photoIndex];
      const image = source.querySelector('img');
      const content = this.$('[data-photo-content]');
      content.replaceChildren();
      if(image) {
        const clone = image.cloneNode(true);
        clone.loading = 'eager';
        clone.removeAttribute('srcset'); clone.removeAttribute('sizes');
        const url = new URL(image.currentSrc || image.src, location.href);
        url.searchParams.set('width', '1800');
        clone.src = url.href;
        content.append(clone);
      } else {
        const svg = source.querySelector('svg');
        if(svg) content.append(svg.cloneNode(true));
      }
      this.$('[data-photo-count]').textContent = (this.photoIndex + 1) + ' / ' + this.photoStages.length;
      this.$('[data-photo-prev]').hidden = this.photoStages.length < 2;
      this.$('[data-photo-next]').hidden = this.photoStages.length < 2;
    }

    disconnectedCallback() {
      clearTimeout(this.preorderTimeout);
      this.abort?.abort(); cancelAnimationFrame(this.mediaFrame); this.classList.remove("wm-carousel-ready"); this.ready = false;
    }
    listen(target, name, fn) { target?.addEventListener(name, fn, {signal:this.abort.signal}); }
    $(s) { return this.querySelector(s); }
    money(value) { return new Intl.NumberFormat(document.documentElement.lang || 'fr-FR', {style:'currency',currency:this.dataset.currency || 'EUR'}).format(value / 100); }
    colour(key, url = true) {
      const c = this.colours.find(x => x.key === key);
      if (!c) return;
      this.key = key;
      this.querySelectorAll('[data-colour-detail]').forEach(x => x.hidden = x.dataset.colourDetail !== key);
      this.querySelectorAll('[data-hero-extra]').forEach(x=>x.hidden=x.dataset.heroExtra!=='all'&&x.dataset.heroExtra!==key);
      this.querySelectorAll('[data-colour]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.colour === key)));
      this.$('[data-colour-name]').textContent = c.label;
      const template = this.querySelector(`template[data-colour-image="${key}"]`);
      if (template) this.$('[data-stage]').replaceChildren(template.content.cloneNode(true));
      this.$('[data-caption]').textContent = c.caption;
      const quantity = this.$('[data-single-quantity]');
      quantity.min = this.live ? c.min : 1;
      quantity.step = this.live ? c.step : 1;
      if (this.live && c.max) quantity.max = c.max; else quantity.removeAttribute('max');
      quantity.value = Math.max(Number(quantity.value) || 1, this.live ? c.min : 1);
      if (url && this.live && c.id) {
        const address = new URL(location.href); address.searchParams.set('variant', c.id); history.replaceState({}, '', address);
      }
      this.resetMedia();
      this.refresh();
    }

    setupMedia() {
      this.mediaQuery = matchMedia('(max-width:749px)');
      this.reducedMotion = matchMedia('(prefers-reduced-motion:reduce)');
      this.mediaIndex = 0;
      this.listen(this.mediaQuery, 'change', () => this.resetMedia());
      this.listen(this.reducedMotion, 'change', () => this.resetMedia());
      this.listen(this.$('[data-media-previous]'), 'click', () => this.manualMedia(-1));
      this.listen(this.$('[data-media-next]'), 'click', () => this.manualMedia(1));
      this.listen(this.$('[data-media-thumbs]'), 'click', e => { const b=e.target.closest('[data-media-index]'); if(b) this.showMedia(Number(b.dataset.mediaIndex)); });
      const stage = this.$('[data-stage]');
      stage.addEventListener('touchstart', e => {const t=e.touches[0]; this.mediaTouch={x:t.clientX,y:t.clientY};}, {passive:true,signal:this.abort.signal});
      stage.addEventListener('touchend', e => {
        if (!this.mediaTouch || !this.mobileMedia()) return;
        const t=e.changedTouches[0], dx=t.clientX-this.mediaTouch.x, dy=t.clientY-this.mediaTouch.y;
        this.mediaTouch=null;
        if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy)*1.5) this.manualMedia(dx<0?1:-1);
      }, {passive:true,signal:this.abort.signal});
      this.listen(this.$('[data-open-dimensions]'), 'click', () => {this.$('.wm-practical details').open=true;});
    }
    mobileMedia() {return this.dataset.mobileCarousel === 'true' && this.mediaQuery.matches;}
    updateGalleryVisibility() {
      this.querySelectorAll('.wm-hero-extras > figure, .wm-hero-extras > [data-gallery-video]').forEach(item => {
        item.hidden = Boolean(item.dataset.heroExtra && item.dataset.heroExtra !== 'all' && item.dataset.heroExtra !== this.key);
      });
    }
    resetMedia() {
      const template=this.querySelector(`template[data-colour-image="${this.key}"]`);
      if(!template)return;
      this.mediaSlides=[{html:template.innerHTML,caption:this.colours.find(c=>c.key===this.key)?.caption || ''},
        ...Array.from(this.querySelectorAll('.wm-hero-extras figure')).filter(f=>!f.hidden).map(f=>({html:f.querySelector('.wm-stage').innerHTML,caption:f.querySelector('figcaption')?.textContent || ''}))];
      const enabled=this.mobileMedia() && this.mediaSlides.length>1;
      this.classList.toggle('wm-carousel-ready', enabled);
      this.$('[data-media-controls]').hidden=true;
      const seen=new Set();
      this.mediaSlides=this.mediaSlides.filter(slide=>{const t=document.createElement('template');t.innerHTML=slide.html;const img=t.content.querySelector('img');const signature=img?.getAttribute('src')?.split('?')[0] || slide.html;if(seen.has(signature))return false;seen.add(signature);return true;});
      const video=this.querySelector('[data-gallery-video] video');
      if(video && this.mobileMedia())this.mediaSlides.push({html:video.outerHTML,caption:this.t.photos,video:true});
      const thumbs=this.$('[data-media-thumbs]');thumbs.replaceChildren();thumbs.hidden=!enabled;
      if(enabled)this.mediaSlides.forEach((slide,i)=>{const button=document.createElement('button');button.type='button';button.dataset.mediaIndex=String(i);button.setAttribute('aria-label',slide.video?'Vidéo des compositions':`${this.t.photo} ${i+1} — ${slide.caption}`);const t=document.createElement('template');t.innerHTML=slide.html;const img=t.content.querySelector('img');if(img){const small=img.cloneNode(true);small.removeAttribute('srcset');small.sizes='56px';small.loading='lazy';small.fetchPriority='low';small.alt='';const url=new URL(small.src,location.href);url.searchParams.set('width','120');small.src=url.href;button.append(small);}else{button.textContent=slide.video?'▶':'↔';}thumbs.append(button);});
      this.mediaBucket=-1; this.mediaManualY=window.scrollY;
      this.showMedia(0);
      const visible = Array.from(this.querySelectorAll('.wm-hero-extras figure')).filter(f => !f.hidden).sort((a,b)=>(b.dataset.view==='image_environment')-(a.dataset.view==='image_environment'));
      visible.forEach((f, i) => { f.style.order = String(i === 0 ? 0 : i + 1); });
      this.updateGalleryVisibility();
      this.preparePhotoTriggers();
    }
    showMedia(index) {
      if(!this.mediaSlides?.length)return;
      this.mediaIndex=Math.max(0,Math.min(index,this.mediaSlides.length-1));
      const slide=this.mediaSlides[this.mediaIndex];
      this.$('[data-stage]').querySelectorAll('video').forEach(v=>v.pause());
      this.$('[data-stage]').innerHTML=slide.html;
      this.$('[data-stage]').querySelectorAll('video').forEach(v=>{v.autoplay=false;v.removeAttribute('autoplay');v.controls=true;v.preload='none';v.playsInline=true;v.pause();});
      this.querySelectorAll('[data-media-index]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.mediaIndex)===this.mediaIndex)));
      this.preparePhotoTriggers();
      this.$('[data-stage]').querySelectorAll('img').forEach(img=>{img.loading='eager';img.fetchPriority=this.mediaIndex===0?'high':'auto';});
      this.$('[data-caption]').textContent=slide.caption;
      this.$('[data-media-count]').textContent=`${this.mediaIndex+1} / ${this.mediaSlides.length}`;
      this.$('[data-media-previous]').disabled=this.mediaIndex===0;
      this.$('[data-media-next]').disabled=this.mediaIndex===this.mediaSlides.length-1;
    }
    manualMedia(direction) {
      if(!this.mobileMedia())return;
      this.mediaManualY=window.scrollY;
      this.showMedia(this.mediaIndex+direction);
    }
    scrollMedia() {
      if(!this.mobileMedia() || this.reducedMotion.matches || !this.mediaSlides?.length)return;
      if(this.mediaManualY!==null && Math.abs(window.scrollY-this.mediaManualY)<80)return;
      this.mediaManualY=null;
      const hero=this.$('.wm-hero').getBoundingClientRect();
      const primary=this.$('.wm-primary');
      const top=parseFloat(getComputedStyle(primary).top)||0;
      if(hero.bottom<=primary.offsetHeight+top || hero.top>top)return;
      const distance=Math.max(1,hero.height-primary.offsetHeight-80);
      const progress=Math.max(0,Math.min(1,(top-hero.top)/distance));
      const bucket=Math.min(this.mediaSlides.length-1,Math.floor(progress*this.mediaSlides.length));
      if(bucket!==this.mediaBucket){this.mediaBucket=bucket;this.showMedia(bucket);}
    }

    quantities() {
      return this.mixed ? this.colours.map(c => ({...c, quantity:Number(this.querySelector(`[data-quantity="${c.key}"]`).value)})) : this.colours.filter(c=>c.key===this.key).map(c=>({...c,quantity:Number(this.$('[data-single-quantity]').value)}));
    }
    selection() {
      const rows = this.quantities().filter(x => x.quantity !== 0);
      if (this.live && this.$('[data-fasten-check]')?.checked && this.$('[data-support]').value === 'hollow') {
        const v = this.data.fasten.find(x=>String(x.id)===this.$('[data-fasten-variant]').value);
        if (v) rows.push({...v,label:this.t.fasten_name,quantity:Number(this.$('[data-fasten-quantity]').value)});
      }
      return rows;
    }
    validate(rows) {
      if (new Set(this.colours.map(c=>c.key)).size !== this.colours.length) return this.t.mapping_error;
      if (this.live && new Set(this.colours.filter(c=>c.id).map(c=>c.id)).size !== this.colours.filter(c=>c.id).length) return this.t.mapping_error;
      if (!this.quantities().some(x=>x.quantity>0)) return this.t.choose_one;
      if (!['pastille','snap'].includes(this.mount)) return this.data.mountText.required;
      for (const row of rows) {
        if (!Number.isSafeInteger(row.quantity) || row.quantity < 1) return this.t.invalid_quantity;
        if (!this.live && (!/^[1-9]\d*$/.test(String(row.id)))) return row.label + ' : ' + this.preorderText.missing_variant;
        if (!this.live && row.quantity > 99) return this.preorderText.invalid_quantity;
        if (this.live) {
          if (!row.id) return `${row.label} : ${this.t.not_linked}`;
          if (!row.available) return `${row.label} : ${this.t.unavailable}`;
          if (row.quantity < row.min || (row.max && row.quantity > row.max) || row.quantity % row.step !== 0) return `${row.label} : ${this.t.quantity_rule} ${row.min}, ${this.t.increment} ${row.step}${row.max ? ', '+this.t.maximum+' '+row.max : ''}.`;
        }
      }
      return '';
    }
    preorderPrice(rows) {
      let count=0,extras=0;
      for(const row of rows){
        if(!Number.isSafeInteger(row.quantity)||row.quantity<1)continue;
        if(this.colours.some(c=>String(c.id)===String(row.id)))count+=row.quantity;
        else {const item=this.data.fasten.find(c=>String(c.id)===String(row.id));if(item)extras+=Number(item.price)*row.quantity;}
      }
      const saving=Math.max(0,count-1)*1500;
      return {count,saving,total:count*19980-saving+extras};
    }
    priceSummary(target,price,label) {
      if(!target)return;
      target.replaceChildren();
      const row=document.createElement('div');row.className='wm-price-row';
      const title=document.createElement('span');title.textContent=label;
      const prices=document.createElement('span');prices.className='wm-price-values';
      if(price.saving>0){const original=document.createElement('s');original.className='wm-price-before';original.textContent=this.preorderMoney(price.total+price.saving);prices.append(original);}
      const total=document.createElement('strong');total.textContent=this.preorderMoney(price.total);prices.append(total);row.append(title,prices);target.append(row);
      if(price.saving){const save=document.createElement('span');save.className='wm-saving';save.textContent=this.preorderText.saving_amount.replace('[amount]',this.preorderMoney(price.saving));target.append(save);}

    }
    preorderMoney(value) {return new Intl.NumberFormat(document.documentElement.lang||'fr-FR',{style:'currency',currency:'EUR',maximumFractionDigits:value%100?2:0}).format(value/100);}
    renderPairBenefits(price) {
      const tracks=this.$('[data-pair-tracks]');if(!tracks)return;
      tracks.replaceChildren();
      const first=Math.max(1,price.count-2);
      for(let quantity=first;quantity<first+5;quantity++){
        const track=document.createElement('div');track.className='wm-pair-track';
        const label=document.createElement('span');label.textContent=this.preorderText.pair_label.replace('[count]',quantity);
        const bar=document.createElement('progress');bar.max=1;bar.value=price.count>=quantity?1:0;bar.setAttribute('aria-label',label.textContent);
        const amount=document.createElement('span');amount.textContent=(quantity>1?'−':'')+this.preorderMoney(Math.max(0,quantity-1)*1500);amount.className=price.count>=quantity?'wm-saving':'';
        track.append(label,bar,amount);tracks.append(track);
      }
      this.$('[data-pair-savings]').textContent=price.saving?this.preorderText.saving_amount.replace('[amount]',this.preorderMoney(price.saving)):this.preorderText.pair_empty;
      this.$('[data-pair-hint]').textContent=price.count?this.preorderText.next_pair.replace('[amount]',this.preorderMoney(price.count*1500)):this.preorderText.offer_note;
      const threshold=Number(this.data.shippingThreshold)||40000;
      const free=price.total>=threshold;
      this.$('[data-delivery-label]').textContent=free?this.preorderText.shipping_free:this.preorderText.shipping_left.replace('[amount]',this.preorderMoney(threshold-price.total));
      let deliveryBar=this.$('[data-delivery-bar]');if(!deliveryBar){deliveryBar=document.createElement('progress');deliveryBar.dataset.deliveryBar='';deliveryBar.style.cssText='width:100%;height:8px;accent-color:#365d47';this.$('[data-pair-benefits]').append(deliveryBar);}deliveryBar.max=threshold;deliveryBar.value=Math.min(price.total,threshold);deliveryBar.setAttribute('aria-label',this.preorderText.shipping_goal.replace('[amount]',this.preorderMoney(threshold)));
      this.$('[data-shipping-check]').textContent=free?'✓':'◇';
      this.$('[data-pair-benefits]').classList.toggle('wm-shipping-earned',free);
    }
    refreshPreorderPrice() {
      if(this.live)return;
      const basket=this.preorderPrice(this.preorderItems);
      this.priceSummary(this.$('[data-basket-price]'),basket,this.preorderText.subtotal);
      const rows=this.quantities().filter(r=>Number.isSafeInteger(r.quantity)&&r.quantity>0);
      const projected=this.preorderPrice([...this.preorderItems,...rows]);
      const selection=this.$('[data-selection-price]');
      this.priceSummary(selection,{total:projected.total-basket.total,saving:projected.saving-basket.saving,count:rows.length?projected.count:0},this.preorderText.selection_price);
      if(selection)selection.hidden=!rows.length;
      this.renderPairBenefits(projected);
    }
    refresh() {
      if (!this.colours.length) {this.$('[data-submit]').disabled=true;return;}
      this.refreshPreorderPrice();
      this.renderMount();
      const selected = this.colours.find(c=>c.key===this.key);
      this.$('[data-unit-price]').textContent = !this.live ? this.preorderText.price_note : selected?.id ? this.money(selected.price) : this.t.price_pending;
      const rows = this.selection();
      this.$('[data-total]').textContent = !this.live ? this.preorderText.price_note : rows.length && rows.every(c=>c.id && Number.isFinite(c.quantity)) ? this.money(rows.reduce((a,b)=>a+b.price*b.quantity,0)) : this.t.price_pending;
      const issue = this.validate(rows);
      this.$('[data-submit]').disabled = this.busy || Boolean(issue && issue!==this.data.mountText.required);
      this.$('[data-error]').hidden = !issue;
      this.$('[data-error]').textContent = issue;
      const count=this.quantities().reduce((sum,row)=>sum+(Number.isSafeInteger(row.quantity)&&row.quantity>0?row.quantity:0),0);
      this.$('[data-submit]').textContent = this.busy ? this.t.adding : this.live ? this.t.add : count===1 ? this.preorderText.add_one : count>1 ? this.preorderText.add_count.replace('[count]',count) : this.preorderText.add;
      if(issue===this.data.mountText.required){this.$('[data-submit]').textContent=this.data.mountText.cta;this.$('[data-error]').hidden=true;}
      if(!this.live && issue===this.t.choose_one)this.$('[data-error]').hidden=true;
      this.querySelectorAll('[data-step-colour]').forEach(button=>{
        const input=this.$('[data-quantity="'+button.dataset.stepColour+'"]');
        button.disabled=Number(button.dataset.step)<0?Number(input.value)<=0:Number(input.value)>=99;
      });
    }
    syncSnap() {
      const guide=document.querySelector('woodvibe-modulo-installation[data-snap-enabled]');
      this.snapEnabled=guide?.dataset.snapEnabled==='true';
      const option=this.$('[data-support] option[value="snap"]');
      if(option){option.hidden=!this.snapEnabled;option.disabled=!this.snapEnabled;}
      this.querySelectorAll('[data-snap-copy]').forEach(el=>el.hidden=(el.dataset.snapCopy==='enabled')!==this.snapEnabled);
      this.support();
    }
    promptMount() {
      const choice=this.$('[data-mount-choice]');
      choice.classList.remove('wm-mount-nudge');
      void choice.offsetWidth;
      choice.classList.add('wm-mount-nudge');
      choice.scrollIntoView({block:'center',behavior:'auto'});
      this.$('[data-mount]').focus({preventScroll:true});
    }
    renderMount() {
      const missing=!['pastille','snap'].includes(this.mount);
      this.$('[data-mount-choice]')?.classList.toggle('wm-mount-needed',missing);
      if(this.$('[data-mount-hint]'))this.$('[data-mount-hint]').hidden=!missing;
      const summary=this.$('[data-mount-summary]');
      if(summary)summary.textContent=this.mount ? this.data.mountText.selected+' '+(this.mount==='snap'?'SNAP':this.data.mountText.pastille) : this.data.mountText.required;
    }
    support() {
      const kind=this.mount==='snap'?'snap':'hollow';
      this.$('[data-support]').value=kind;
      if(this.$('[data-fasten]')) {
        this.$('[data-fasten]').hidden=this.mount!=='pastille';
        if(this.mount!=='pastille')this.$('[data-fasten-check]').checked=false;
      }
    }
    setMix(value) {
      this.mixed=value;this.$('[data-mix]').hidden=!value;this.$('[data-single]').hidden=value;
      this.$('[data-toggle-mix]').setAttribute('aria-expanded',String(value));
      this.$('[data-toggle-mix]').textContent=value?this.t.single_colour:this.t.mix;
      this.$('[data-colour-name]').textContent=value?this.t.multicolour:this.colours.find(c=>c.key===this.key)?.label || '';
      if(value)this.querySelectorAll('[data-quantity]').forEach(x=>x.value=x.dataset.quantity===this.key?this.$('[data-single-quantity]').value:0);
      this.refresh();
    }
    click(e) {
      const fixingLink=e.target.closest('[data-detail-fix-link]');
      if(fixingLink){e.preventDefault();const destination=document.getElementById('ModuloFix');if(!destination)return;destination.setAttribute('tabindex','-1');destination.scrollIntoView({block:'start',behavior:'auto'});destination.focus({preventScroll:true});return;}

      const b=e.target.closest('button');if(!b || !this.contains(b))return;
      if(b.dataset.previewColour){this.colour(b.dataset.previewColour,false);return;}
      if(b.dataset.stepColour){
        const input=this.$('[data-quantity="'+b.dataset.stepColour+'"]');
        input.value=Math.max(0,Math.min(99,(Number(input.value)||0)+Number(b.dataset.step)));
        this.colour(b.dataset.stepColour,false);this.refresh();return;
      }
      if(b.hasAttribute('data-add-fixings')){
        const variant=this.data.fasten.find(v=>String(v.id)===this.$('[data-fasten-variant]').value);
        const quantity=Number(this.$('[data-fasten-quantity]').value);
        if(!variant || !Number.isSafeInteger(quantity) || quantity<1 || quantity>99){this.$('[data-error]').hidden=false;this.$('[data-error]').textContent=this.preorderText.invalid_quantity;return;}
        this.addPreorder([{...variant,label:this.t.fasten_name,quantity}]);return;
      }
      if(b.hasAttribute('data-preorder-remove')){
        this.preorderItems=this.preorderItems.filter(x=>x.id!==b.dataset.preorderRemove);
        this.persistPreorder();this.renderPreorder();return;
      }
      if(b.hasAttribute('data-detail-zoom')){const d=this.$('[data-detail-dialog]'),i=d.querySelector('img');i.src=b.dataset.detailZoom;i.alt=b.querySelector('img').alt;d.showModal();}
      if(b.hasAttribute('data-detail-close'))this.$('[data-detail-dialog]').close();
      if(b.dataset.colour){if(this.mixed)this.setMix(false);this.colour(b.dataset.colour);}
      if(b.hasAttribute('data-toggle-mix'))this.setMix(!this.mixed);
      if(b.hasAttribute('data-detail')){this.querySelectorAll('[data-detail]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));this.querySelectorAll('[data-detail-panel]').forEach(x=>x.hidden=x.dataset.detailPanel!==b.dataset.detail);}
    }
    reproduce(card) {
      if(!card || !this.ready)return;
      this.setMix(true);
      this.querySelectorAll('[data-quantity]').forEach(x=>x.value=Number(card.dataset[x.dataset.quantity])||0);
      const picture=card.querySelector('img,svg');
      if(picture)this.$('[data-stage]').replaceChildren(picture.cloneNode(true));
      this.$('[data-caption]').textContent=card.querySelector('[data-composition-label]').textContent;
      this.$('[data-status]').textContent=this.t.composition_applied;
      this.refresh();this.$('[data-mix]').scrollIntoView({block:'center',behavior:'auto'});this.$('[data-quantity]').focus({preventScroll:true});
    }

    restorePreorder() {
      const catalogue = [...this.colours, ...this.data.fasten];
      try {
        const saved = JSON.parse(localStorage.getItem('woodvibe:preorder:modulo:v1') || '[]');
        if (Array.isArray(saved)) this.preorderItems = saved.filter(x => catalogue.some(c => String(c.id) === String(x.id)) && Number.isSafeInteger(x.quantity) && x.quantity > 0 && x.quantity <= 99).map(x => {
          const c = catalogue.find(c => String(c.id) === String(x.id));
          return {id:String(c.id),label:c.label || this.t.fasten_name,quantity:x.quantity};
        });
      } catch { this.preorderItems = []; }
      if (this.$('[data-preorder-success]')) {
        const summary=this.$('[data-preorder-confirmed-lines]');
        this.preorderItems.forEach(item=>{const li=document.createElement('li');li.textContent=item.quantity+' × '+item.label;summary?.append(li);});
        this.$('[data-preorder-success]').focus({preventScroll:true});
        this.$('[data-preorder-success]').scrollIntoView({block:'center',behavior:'auto'});
        this.preorderItems = [];
        this.persistPreorder();
      }
      this.renderPreorder();
    }
    persistPreorder() {
      try {localStorage.setItem('woodvibe:preorder:modulo:v1', JSON.stringify(this.preorderItems));} catch {}
    }
    renderPreorder() {
      const container=this.$('[data-preorder-lines]');
      if(!container)return;
      container.replaceChildren();
      this.preorderItems.forEach(item=>{
        const line=document.createElement('div');line.className='wm-preorder-line';
        const label=document.createElement('span');label.className='wm-basket-label';
        const colour=this.colours.find(c=>String(c.id)===item.id);
        if(colour?.swatch){const dot=document.createElement('span');dot.className='wm-dot';dot.style.setProperty('--wm-dot',colour.swatch);dot.setAttribute('aria-hidden','true');label.append(dot);}
        const name=document.createElement('span');name.textContent=item.label;label.append(name);
        const input=document.createElement('input');input.type='number';input.min='1';input.max='99';input.step='1';input.value=item.quantity;input.dataset.preorderQuantity=item.id;input.setAttribute('aria-label',this.preorderText.quantity+' — '+item.label);
        const remove=document.createElement('button');remove.type='button';remove.className='wm-text';remove.dataset.preorderRemove=item.id;remove.textContent=this.preorderText.remove;remove.setAttribute('aria-label',this.preorderText.remove+' — '+item.label);
        line.append(label,input,remove);container.append(line);
      });
      this.$('[data-preorder-count]').textContent=String(this.preorderItems.reduce((sum,x)=>sum+x.quantity,0));
      this.$('[data-preorder-empty]').hidden=this.preorderItems.length>0;
      this.$('[data-preorder-details]').hidden=this.preorderItems.length===0;
      this.$('[data-preorder-error]').hidden=true;
      this.refreshPreorderPrice();
      this.renderMount();
    }
    addPreorder(rows) {
      const next=this.preorderItems.map(x=>({...x}));
      for(const row of rows){
        const id=String(row.id),existing=next.find(x=>x.id===id);
        if((existing?.quantity||0)+row.quantity>99){
          this.$('[data-error]').hidden=false;this.$('[data-error]').textContent=this.preorderText.invalid_quantity;return;
        }
        if(existing)existing.quantity+=row.quantity;
        else next.push({id,label:row.label,quantity:row.quantity});
      }
      this.preorderItems=next;this.persistPreorder();
      if(rows.some(row=>this.colours.some(c=>String(c.id)===String(row.id))))this.querySelectorAll('[data-quantity]').forEach(input=>{input.value='0';});
      this.renderPreorder();this.refresh();
      this.$('[data-status]').textContent=this.preorderText.added;
      this.$('[data-preorder-lines]').scrollIntoView({block:'center',behavior:'auto'});
    }
    resetPreorderSubmission() {
      clearTimeout(this.preorderTimeout);
      this.preorderSaving=false;
      const save=this.$('[data-preorder-save]');
      if(save){save.disabled=false;save.textContent=this.preorderText.save;save.removeAttribute('aria-busy');}
    }
    savePreorder(event) {
      if(!this.preorderItems.length){event.preventDefault();return;}
      if(!['pastille','snap'].includes(this.mount)) {
        event.preventDefault();
        this.$('[data-preorder-error]').hidden=false;
        this.$('[data-preorder-error]').textContent=this.data.mountText.required;
        this.promptMount();return;
      }
      const email=this.$('[data-waitlist-email]'),consent=this.$('[data-waitlist-consent]'),error=this.$('[data-preorder-error]');
      if(!email.reportValidity() || !consent.reportValidity()){event.preventDefault();return;}
      const form=this.$('.wm-waitlist-shopify');
      if(!form){event.preventDefault();error.hidden=false;error.textContent=this.preorderText.unavailable_form;return;}
      const items=this.preorderItems.map(x=>x.id+':'+x.quantity);
      const stamp=new Date().toISOString().replace(/[-:.]/g,'').slice(0,15)+'Z';
      const cartTag=['WV_PREORDER_CART',stamp,'MODULO',...items].join('|');
      if(cartTag.length>255){event.preventDefault();error.hidden=false;error.textContent=this.preorderText.unavailable_form;return;}
      form.querySelector('[data-waitlist-tags]').value=['Modulo liste attente','WV_PREORDER',cartTag,'WV_PREORDER_FIXING|'+stamp+'|'+this.mount.toUpperCase()].join(', ');
      email.value=email.value.trim();
      const destination=new URL(location.href);
      if(this.dataset.templateView)destination.searchParams.set('view',this.dataset.templateView);
      destination.searchParams.set('customer_posted','true');
      destination.hash=form.id;
      form.querySelector('[data-preorder-return]').value=destination.pathname+destination.search+destination.hash;
      error.hidden=true;
      this.preorderSaving=true;
      const save=this.$('[data-preorder-save]');save.textContent=this.preorderText.saving;save.setAttribute('aria-busy','true');
      clearTimeout(this.preorderTimeout);
      this.preorderTimeout=setTimeout(()=>{
        this.resetPreorderSubmission();
        error.hidden=false;error.textContent=this.preorderText.unavailable_form;
      },20000);
    }

    async submit(e) {
      e.preventDefault();if(this.busy)return;
      const rows=this.selection(),error=this.validate(rows);
      if(error){this.refresh();if(error===this.data.mountText.required)this.promptMount();return;}
      if(!this.live){this.addPreorder(rows);return;}
      this.busy=true;this.refresh();this.$('[data-status]').textContent='';
      const merged=new Map();rows.forEach(r=>merged.set(r.id,(merged.get(r.id)||0)+r.quantity));
      const cart=document.querySelector('cart-drawer');
      const sections=cart?.getSectionsToRender?.().map(x=>x.id)||[];
      const body={items:Array.from(merged,([id,quantity])=>({id,quantity,...(this.colours.some(c=>String(c.id)===String(id))?{properties:{Fixation:this.mount==='snap'?'SNAP':this.data.mountText.pastille}}:{})})),sections_url:location.pathname};
      if(sections.length)body.sections=sections;
      cart?.setActiveElement?.(this.$('[data-submit]'));
      let added=false;
      try {
        const root=window.Shopify?.routes?.root || this.dataset.root || '/';
        const response=await fetch(root.replace(/\/?$/,'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
        const payload=await response.json();
        if(!response.ok || payload.status){throw new Error(typeof payload.description==='string'?payload.description:this.t.add_error);}
        added=true;
        this.$('[data-status]').textContent=this.t.added;
        if(cart && sections.length && sections.every(id=>typeof payload.sections?.[id]==='string')){
          try{cart.classList.remove('is-empty');cart.renderContents(payload);}catch{location.assign(root+'cart');}
        }else{location.assign(root+'cart');}
      }catch(err){
        this.$('[data-error]').hidden=false;
        this.$('[data-error]').textContent=added?this.t.cart_check:(err instanceof TypeError?this.t.network_error:err.message);
        const a=document.createElement('a');a.href=(window.Shopify?.routes?.root||this.dataset.root||'/')+'cart';a.textContent=this.t.view_cart;
        this.$('[data-error]').append(' ',a);
      }finally{this.busy=false;this.$('[data-submit]').disabled=false;this.$('[data-submit]').textContent=this.t.add;}
    }
  });
}



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new-pack-premium"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new-premium"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-new"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-preco"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-premium"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(
        `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
      ).forEach((element) => {
        element.classList.remove('active');
      });
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMediaContent &&
        activeMediaContent.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modulo-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woodvibe-modulo-gallery')){
 customElements.define('woodvibe-modulo-gallery',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.abort=new AbortController();this.t={photo:this.dataset.photoLabel};
   this.listen(this,'click',e=>{const b=e.target.closest('button');if(!b||!this.contains(b))return;
    if(b.hasAttribute('data-gallery-zoom')){
     const img=b.querySelector('img'),large=document.createElement('img');
     large.src=b.dataset.galleryZoom;large.alt=img.alt;large.width=img.naturalWidth||1536;large.height=img.naturalHeight||1024;
     this.$('[data-gallery-enlargement]').replaceChildren(large);
     this.$('[data-gallery-caption]').textContent=b.closest('[data-composition]').dataset.caption;
     this.$('[data-gallery-dialog]').showModal();
    }
    if(b.hasAttribute('data-gallery-close'))this.$('[data-gallery-dialog]').close();
    if(b.dataset.category)this.filter(b.dataset.category);
    if(b.hasAttribute('data-slide'))this.move(Number(b.dataset.slide));
    if(b.hasAttribute('data-prev'))this.move(this.slide-1);
    if(b.hasAttribute('data-next'))this.move(this.slide+1);
    if(b.hasAttribute('data-reproduce'))document.querySelector('woodvibe-modulo')?.reproduce(b.closest('[data-composition]'));
   });
   this.listen(this.$('[data-gallery-dialog]'),'click',e=>{if(e.target===this.$('[data-gallery-dialog]'))this.$('[data-gallery-dialog]').close();});
   this.listen(this.$('[data-carousel]'),'scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>this.galleryPosition());});
   this.listen(document,'shopify:block:select',e=>{
    const card=[...this.querySelectorAll('[data-composition]')].find(c=>c.dataset.blockId===e.detail?.blockId)||e.target.closest('[data-composition]');
    if(card&&this.contains(card)){this.filter(card.closest('[data-gallery-group]').dataset.galleryGroup);this.move(this.cards.indexOf(card),true);return;}
    const group=[...this.querySelectorAll('[data-gallery-group]')].find(g=>g.dataset.groupId===e.detail?.blockId)||e.target.closest('[data-gallery-group]');
    if(group&&this.contains(group)){this.filter(group.dataset.galleryGroup);const first=group.querySelector('[data-composition]');if(first)this.move(this.cards.indexOf(first),true);}

   });
   const product=document.querySelector('woodvibe-modulo');
   const colours=product?.querySelector('[data-modulo-data]');
   if(colours){const data=JSON.parse(colours.textContent);this.querySelectorAll('[data-composition]').forEach(card=>{card.querySelector('[data-composition-label]').textContent=data.colours.filter(c=>Number(card.dataset[c.key])>0).map(c=>`${card.dataset[c.key]} × ${c.label}`).join(' · ');});}
   this.filter(this.querySelector('[data-gallery-group]')?.dataset.galleryGroup||'chevet');
   this.orderObserver=new MutationObserver(records=>{
    if(records.some(r=>r.target.matches?.('[data-gallery-group], [data-carousel]'))){this.filter(this.category);}
   });
   this.orderObserver.observe(this.$('[data-carousel]'),{childList:true,subtree:true});
   this.resize=new ResizeObserver(()=>this.galleryPosition());this.resize.observe(this.$('[data-carousel]'));
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.orderObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);this.ready=false;}
  listen(target,name,fn){target?.addEventListener(name,fn,{signal:this.abort.signal});}
  $(s){return this.querySelector(s);}
    filter(category) {
      this.category=category;
      this.querySelectorAll('[data-composition]').forEach(c=>c.dataset.categoryValue=c.closest('[data-gallery-group]').dataset.galleryGroup);
      this.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===category)));
      this.querySelectorAll('[data-composition]').forEach(c=>c.hidden=c.dataset.categoryValue!==category);
      this.cards=Array.from(this.querySelectorAll('[data-composition]')).filter(c=>!c.hidden);
      this.$('[data-gallery-empty]').hidden=Boolean(this.cards.length);
      this.$('[data-dots]').replaceChildren(...this.cards.map((c,i)=>{const b=document.createElement('button');b.type='button';b.dataset.slide=i;b.setAttribute('aria-label',`${this.t.photo} ${i+1} : ${c.dataset.caption}`);return b;}));
      this.$('[data-carousel]').scrollLeft=0;this.galleryPosition();
    }
    galleryPosition() {
      if(!this.cards?.length){this.$('[data-counter]').textContent='0 / 0';this.$('[data-prev]').disabled=true;this.$('[data-next]').disabled=true;return;}
      const carousel=this.$('[data-carousel]'),left=carousel.getBoundingClientRect().left;
      this.slide=this.cards.reduce((a,c,i)=>Math.abs(c.getBoundingClientRect().left-left)<Math.abs(this.cards[a].getBoundingClientRect().left-left)?i:a,0);
      this.querySelectorAll('[data-slide]').forEach(b=>b.setAttribute('aria-current',String(Number(b.dataset.slide)===this.slide)));
      this.$('[data-counter]').textContent=`${this.slide+1} / ${this.cards.length}`;
      this.$('[data-prev]').disabled=carousel.scrollLeft<2;
      this.$('[data-next]').disabled=carousel.scrollLeft+carousel.clientWidth>=carousel.scrollWidth-2;
    }
    move(index, instant = false) {
      const c=this.cards?.[Math.max(0,Math.min(index,this.cards.length-1))];if(!c)return;
      const rail=this.$('[data-carousel]');rail.scrollTo({left:rail.scrollLeft+c.getBoundingClientRect().left-rail.getBoundingClientRect().left,behavior:instant?'auto':matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["modulo-installation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woodvibe-modulo-installation')){
 customElements.define('woodvibe-modulo-installation',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.abort=new AbortController();

   this.initGroups();
   this.listen(this,'click',e=>{const b=e.target.closest('button');if(!b||!this.contains(b))return;
    if(b.hasAttribute('data-step-prev'))this.stepMove(b.closest('[data-steps]'),-1);
    if(b.hasAttribute('data-step-next'))this.stepMove(b.closest('[data-steps]'),1);
    if(b.hasAttribute('data-zoom')){this.$('[data-zoom-content]').replaceChildren(b.firstElementChild.cloneNode(true));this.$('.wm-zoom-dialog').showModal();}
    if(b.hasAttribute('data-close-zoom'))this.$('.wm-zoom-dialog').close();
    if(b.dataset.fixTab)this.selectGroup(b.dataset.fixTab);
   });
   this.querySelectorAll('[data-steps]').forEach(gallery=>{const rail=gallery.querySelector('[data-step-rail]');this.listen(rail,'scroll',()=>this.stepPosition(gallery));this.listen(rail,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stepMove(gallery,e.key==='ArrowRight'?1:-1);}});this.stepPosition(gallery);});
   this.resize=new ResizeObserver(()=>this.querySelectorAll('[data-steps]').forEach(g=>this.stepPosition(g)));this.querySelectorAll('[data-step-rail]').forEach(rail=>this.resize.observe(rail));
   this.listen(document,'shopify:block:select',e=>{
    if(!this.contains(e.target))return;
    const panel=e.target.closest('[data-fix-panel]');if(!panel)return;
    this.selectGroup(panel.dataset.fixPanel);
    requestAnimationFrame(()=>e.target.closest('.wm-step')?.scrollIntoView({block:'nearest',inline:'start',behavior:'instant'}));
   });
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.$('dialog')?.close();this.ready=false;queueMicrotask(()=>document.dispatchEvent(new CustomEvent('woodvibe:snap-visibility-change')));}

  initGroups(){
   const panels=[...this.querySelectorAll('[data-fix-panel]')];
   const enabled=panels.filter(p=>p.dataset.enabled==='true');
   // Theme blocks supply their actual IDs and titles through their rendered markup.
   this.$('[data-install-tabs]').replaceChildren(...enabled.map(panel=>{
    const button=document.createElement('button');button.type='button';
    button.dataset.fixTab=panel.dataset.fixPanel;
    button.setAttribute('aria-controls',panel.id);
    button.setAttribute('aria-pressed','false');
    button.textContent=panel.dataset.tabTitle;
    return button;
   }));
   this.dataset.snapEnabled=String(enabled.some(p=>p.dataset.support==='snap'));
   this.querySelectorAll('[data-steps]').forEach(g=>{
    const cards=[...g.querySelectorAll('[data-install-step]')];
    cards.forEach((c,i)=>c.querySelector('[data-step-number]').textContent=i+1);
    g.hidden=!cards.length;
   });
   this.selectGroup(this.querySelector('[data-fix-tab]')?.dataset.fixTab);
   queueMicrotask(()=>document.dispatchEvent(new CustomEvent('woodvibe:snap-visibility-change')));
  }
  selectGroup(id){
   this.querySelectorAll('[data-fix-tab]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fixTab===id)));
   this.querySelectorAll('[data-fix-panel]').forEach(p=>p.hidden=p.dataset.fixPanel!==id);
   requestAnimationFrame(()=>this.querySelectorAll('[data-steps]').forEach(g=>this.stepPosition(g)));
  }
  listen(target,name,fn){target?.addEventListener(name,fn,{signal:this.abort.signal});}
  $(s){return this.querySelector(s);}
    stepPosition(gallery) {
      const rail=gallery.querySelector('[data-step-rail]'),cards=[...rail.children];if(!cards.length||!rail.clientWidth)return;
      const left=rail.getBoundingClientRect().left,right=left+rail.clientWidth;
      const visible=cards.map((c,i)=>({i,r:c.getBoundingClientRect()})).filter(x=>x.r.left<right-20&&x.r.right>left+20);
      if(!visible.length)return;
      gallery.querySelector('[data-step-counter]').textContent=`${gallery.dataset.stepLabel} ${visible[0].i+1}${visible.length>1?'–'+(visible.at(-1).i+1):''} / ${cards.length}`;
      gallery.querySelector('[data-step-prev]').disabled=rail.scrollLeft<2;
      gallery.querySelector('[data-step-next]').disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;
    }
    stepMove(gallery,delta) {
      const rail=gallery.querySelector('[data-step-rail]'),card=rail.firstElementChild;
      if(!card)return;
      const gap=parseFloat(getComputedStyle(rail).gap)||0;
      rail.scrollBy({left:delta*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pastilles-finish"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woodvibe-finish'))customElements.define('woodvibe-finish',class extends HTMLElement{
 connectedCallback(){if(this.abort)return;this.abort=new AbortController();const signal=this.abort.signal;const sync=()=>{const snap=!!document.querySelector('woodvibe-modulo-installation[data-snap-enabled="true"],woodvibe-shelf-installation[data-snap-enabled="true"]');this.querySelectorAll('[data-finish-copy]').forEach(e=>e.hidden=(e.dataset.finishCopy==='snap')!==snap);};sync();document.addEventListener('woodvibe:snap-visibility-change',sync,{signal});this.addEventListener('click',e=>{const b=e.target.closest('[data-finish]');if(!b)return;this.querySelectorAll('[data-finish]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));this.querySelectorAll('[data-finish-panel]').forEach(x=>x.hidden=x.dataset.finishPanel!==b.dataset.finish);},{signal});}
 disconnectedCallback(){this.abort?.abort();this.abort=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shelf-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woodvibe-shelf-gallery')){
 customElements.define('woodvibe-shelf-gallery',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.abort=new AbortController();this.t={photo:this.dataset.photoLabel};
   this.listen(this,'click',e=>{const b=e.target.closest('button');if(!b||!this.contains(b))return;
    if(b.hasAttribute('data-shelf-zoom')){const d=this.$('[data-shelf-dialog]');d.querySelector('img').src=b.dataset.shelfZoom;d.querySelector('img').alt=b.querySelector('img').alt;d.querySelector('p').textContent=b.closest('[data-composition]').dataset.caption;d.showModal();}
    if(b.hasAttribute('data-shelf-close'))this.$('[data-shelf-dialog]').close();
    if(b.dataset.category)this.filter(b.dataset.category);
    if(b.hasAttribute('data-slide'))this.move(Number(b.dataset.slide));
    if(b.hasAttribute('data-prev'))this.move(this.slide-1);
    if(b.hasAttribute('data-next'))this.move(this.slide+1);
   });
   this.listen(this.$('[data-carousel]'),'scroll',()=>{cancelAnimationFrame(this.scrollFrame);this.scrollFrame=requestAnimationFrame(()=>this.galleryPosition());});
   this.listen(document,'shopify:block:select',e=>{
    const card=[...this.querySelectorAll('[data-composition]')].find(c=>c.dataset.blockId===e.detail?.blockId)||e.target.closest('[data-composition]');
    if(card&&this.contains(card)){this.filter(card.closest('[data-gallery-group]').dataset.galleryGroup);this.move(this.cards.indexOf(card),true);return;}
    const group=[...this.querySelectorAll('[data-gallery-group]')].find(g=>g.dataset.groupId===e.detail?.blockId)||e.target.closest('[data-gallery-group]');
    if(group&&this.contains(group)){this.filter(group.dataset.galleryGroup);const first=group.querySelector('[data-composition]');if(first)this.move(this.cards.indexOf(first),true);}

   });
   const first=this.querySelector('[data-composition]')?.closest('[data-gallery-group]');
   this.filter(first?.dataset.galleryGroup||'chevet');
   this.orderObserver=new MutationObserver(records=>{
    if(records.some(r=>r.target.matches?.('[data-gallery-group], [data-carousel]'))){this.filter(this.category);}
   });
   this.orderObserver.observe(this.$('[data-carousel]'),{childList:true,subtree:true});
   this.resize=new ResizeObserver(()=>this.galleryPosition());this.resize.observe(this.$('[data-carousel]'));
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.orderObserver?.disconnect();cancelAnimationFrame(this.scrollFrame);this.ready=false;}
  listen(target,name,fn){target?.addEventListener(name,fn,{signal:this.abort.signal});}
  $(s){return this.querySelector(s);}
    filter(category) {
      this.category=category;
      this.querySelectorAll('[data-category]').forEach(b=>{
        b.hidden=this.dataset.designMode!=='true' && ![...this.querySelectorAll('[data-gallery-group]')].some(g=>g.dataset.galleryGroup===b.dataset.category && g.querySelector('[data-composition]'));
      });
      this.querySelectorAll('[data-composition]').forEach(c=>c.dataset.categoryValue=c.closest('[data-gallery-group]').dataset.galleryGroup);
      this.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category===category)));
      this.querySelectorAll('[data-composition]').forEach(c=>c.hidden=c.dataset.categoryValue!==category);
      this.cards=Array.from(this.querySelectorAll('[data-composition]')).filter(c=>!c.hidden);
      this.$('[data-gallery-empty]').hidden=Boolean(this.cards.length);
      this.$('[data-dots]').replaceChildren(...this.cards.map((c,i)=>{const b=document.createElement('button');b.type='button';b.dataset.slide=i;b.setAttribute('aria-label',`${this.t.photo} ${i+1} : ${c.dataset.caption}`);return b;}));
      this.$('[data-carousel]').scrollLeft=0;this.galleryPosition();
    }
    galleryPosition() {
      if(!this.cards?.length){this.$('[data-counter]').textContent='0 / 0';this.$('[data-prev]').disabled=true;this.$('[data-next]').disabled=true;return;}
      const carousel=this.$('[data-carousel]'),left=carousel.getBoundingClientRect().left;
      this.slide=this.cards.reduce((a,c,i)=>Math.abs(c.getBoundingClientRect().left-left)<Math.abs(this.cards[a].getBoundingClientRect().left-left)?i:a,0);
      this.querySelectorAll('[data-slide]').forEach(b=>b.setAttribute('aria-current',String(Number(b.dataset.slide)===this.slide)));
      this.$('[data-counter]').textContent=`${this.slide+1} / ${this.cards.length}`;
      this.$('[data-prev]').disabled=carousel.scrollLeft<2;
      this.$('[data-next]').disabled=carousel.scrollLeft+carousel.clientWidth>=carousel.scrollWidth-2;
    }
    move(index, instant = false) {
      const c=this.cards?.[Math.max(0,Math.min(index,this.cards.length-1))];if(!c)return;
      const rail=this.$('[data-carousel]');rail.scrollTo({left:rail.scrollLeft+c.getBoundingClientRect().left-rail.getBoundingClientRect().left,behavior:instant?'auto':matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shelf-installation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woodvibe-shelf-installation')){
 customElements.define('woodvibe-shelf-installation',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.abort=new AbortController();
   this.querySelectorAll('[data-steps]').forEach(gallery=>{
    if(!gallery.querySelector('[data-install-step]')||gallery.querySelector('.shelf-step-hint'))return;
    const hint=document.createElement('p');hint.className='shelf-step-hint';hint.textContent=this.dataset.slideHint;
    gallery.prepend(hint);
    const next=gallery.querySelector('[data-step-next]');next.textContent=this.dataset.nextLabel+' →';
   });
   this.initGroups();
   this.listen(this,'click',e=>{const b=e.target.closest('button');if(!b||!this.contains(b))return;
    if(b.hasAttribute('data-step-prev'))this.stepMove(b.closest('[data-steps]'),-1);
    if(b.hasAttribute('data-step-next'))this.stepMove(b.closest('[data-steps]'),1);
    if(b.hasAttribute('data-zoom')){this.$('[data-zoom-content]').replaceChildren(b.firstElementChild.cloneNode(true));this.$('.wm-zoom-dialog').showModal();}
    if(b.hasAttribute('data-close-zoom'))this.$('.wm-zoom-dialog').close();
    if(b.dataset.fixTab)this.selectGroup(b.dataset.fixTab);
    if(b.dataset.finish){this.querySelectorAll('[data-finish]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));this.querySelectorAll('[data-finish-panel]').forEach(x=>x.hidden=x.dataset.finishPanel!==b.dataset.finish);}
   });
   this.querySelectorAll('[data-steps]').forEach(gallery=>{const rail=gallery.querySelector('[data-step-rail]');this.listen(rail,'scroll',()=>this.stepPosition(gallery));this.listen(rail,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stepMove(gallery,e.key==='ArrowRight'?1:-1);}});this.stepPosition(gallery);});
   this.resize=new ResizeObserver(()=>this.querySelectorAll('[data-steps]').forEach(g=>this.stepPosition(g)));this.querySelectorAll('[data-step-rail]').forEach(rail=>this.resize.observe(rail));
   this.listen(document,'shopify:block:select',e=>{
    if(!this.contains(e.target))return;
    const panel=e.target.closest('[data-fix-panel]');if(!panel)return;
    this.selectGroup(panel.dataset.fixPanel);
    requestAnimationFrame(()=>e.target.closest('.wm-step')?.scrollIntoView({block:'nearest',inline:'start',behavior:'instant'}));
   });
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.$('dialog')?.close();this.ready=false;}

  initGroups(){
   const panels=[...this.querySelectorAll('[data-fix-panel]')];
   const enabled=panels.filter(p=>p.dataset.enabled==='true');
   // Theme blocks supply their actual IDs and titles through their rendered markup.
   this.$('[data-install-tabs]').replaceChildren(...enabled.map(panel=>{
    const button=document.createElement('button');button.type='button';
    button.dataset.fixTab=panel.dataset.fixPanel;
    button.setAttribute('aria-controls',panel.id);
    button.setAttribute('aria-pressed','false');
    button.textContent=panel.dataset.tabTitle;
    return button;
   }));
   this.dataset.snapEnabled=String(enabled.some(p=>p.dataset.support==='snap'));
   this.querySelectorAll('[data-finish-copy]').forEach(copy=>{
    copy.hidden=(copy.dataset.finishCopy==='snap')!==(this.dataset.snapEnabled==='true');
   });
   this.querySelectorAll('[data-steps]').forEach(g=>{
    const cards=[...g.querySelectorAll('[data-install-step]')];
    cards.forEach((c,i)=>c.querySelector('[data-step-number]').textContent=i+1);
    g.hidden=!cards.length;
   });
   this.selectGroup(this.querySelector('[data-fix-tab]')?.dataset.fixTab);
   queueMicrotask(()=>document.dispatchEvent(new CustomEvent('woodvibe:snap-visibility-change')));
  }
  selectGroup(id){
   this.querySelectorAll('[data-fix-tab]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fixTab===id)));
   this.querySelectorAll('[data-fix-panel]').forEach(p=>p.hidden=p.dataset.fixPanel!==id);
   requestAnimationFrame(()=>this.querySelectorAll('[data-steps]').forEach(g=>this.stepPosition(g)));
  }
  listen(target,name,fn){target?.addEventListener(name,fn,{signal:this.abort.signal});}
  $(s){return this.querySelector(s);}
    stepPosition(gallery) {
      const rail=gallery.querySelector('[data-step-rail]'),cards=[...rail.children];if(!cards.length||!rail.clientWidth)return;
      const left=rail.getBoundingClientRect().left,right=left+rail.clientWidth;
      const visible=cards.map((c,i)=>({i,r:c.getBoundingClientRect()})).filter(x=>Math.min(x.r.right,right)-Math.max(x.r.left,left)>=Math.min(x.r.width,rail.clientWidth)*.5);
      if(!visible.length)return;
      gallery.querySelector('[data-step-counter]').textContent=`${gallery.dataset.stepLabel} ${visible[0].i+1}${visible.length>1?'–'+(visible.at(-1).i+1):''} / ${cards.length}`;
      gallery.querySelector('[data-step-prev]').disabled=rail.scrollLeft<2;
      gallery.querySelector('[data-step-next]').disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;
    }
    stepMove(gallery,delta) {
      const rail=gallery.querySelector('[data-step-rail]'),card=rail.firstElementChild;
      if(!card)return;
      const gap=parseFloat(getComputedStyle(rail).gap)||0;
      rail.scrollBy({left:delta*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shelf-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('woodvibe-shelf-story')) {
  customElements.define('woodvibe-shelf-story', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const dialog = this.querySelector('[data-story-dialog]');
      this.querySelectorAll('[data-story-zoom]').forEach(button => button.addEventListener('click', () => {
        const target = dialog.querySelector('img');
        target.src = button.dataset.storyZoom;
        target.alt = button.querySelector('img').alt;
        dialog.showModal();
      }, {signal: this.controller.signal}));
      this.querySelector('[data-story-close]').addEventListener('click', () => dialog.close(), {signal: this.controller.signal});
      const update = () => {
        const enabled = !!document.querySelector('woodvibe-shelf-installation [data-support="snap"][data-enabled="true"]');
        this.querySelectorAll('[data-shelf-snap-copy]').forEach(copy => copy.hidden = !enabled);
      };
      ['woodvibe:snap-visibility-change', 'shopify:section:load', 'shopify:section:unload'].forEach(name => document.addEventListener(name, update, {signal: this.controller.signal}));
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["woodvibe-shared-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woodvibe-shared-gallery')){
customElements.define('woodvibe-shared-gallery',class extends HTMLElement{
 connectedCallback(){
  if(this.initialized)return;
  this.initialized=true;
  this.photos=[...this.querySelectorAll('.wvg-photo')];
  this.dialog=this.querySelector('dialog');
  if(!this.dialog)return;
  this.addEventListener('click',e=>{
   const filter=e.target.closest('[data-filter]');
   if(filter){
    this.querySelectorAll('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',String(b===filter)));
    this.photos.forEach(p=>p.hidden=filter.dataset.filter!=='all'&&!p.dataset.categories.split(' ').includes(filter.dataset.filter));
   }
   const photo=e.target.closest('.wvg-photo');
   if(photo){this.active=photo;this.show(0);this.dialog.showModal();}
   if(e.target.closest('[data-close]'))this.dialog.close();
   if(e.target.closest('[data-prev]'))this.show(-1);
   if(e.target.closest('[data-next]'))this.show(1);
   if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}
  });
  this.dialog.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();this.show(-1);}if(e.key==='ArrowRight'){e.preventDefault();this.show(1);}});
  this.dialog.addEventListener('close',()=>this.active?.focus());
 }
 show(step){
  const list=this.photos.filter(p=>!p.hidden);
  const index=(list.indexOf(this.active)+step+list.length)%list.length;
  this.active=list[index];
  const image=this.querySelector('[data-large]');
  image.src=this.active.dataset.full;
  image.alt=this.active.querySelector('img').alt;
  this.querySelector('[data-count]').textContent=(index+1)+' / '+list.length;
 }
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-accessoires-launch"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wv-launch-slides'))customElements.define('wv-launch-slides',class extends HTMLElement{
connectedCallback(){this.slides=[...this.querySelectorAll('.wv-launch__slide')];this.index=0;this.abort=new AbortController();const opt={signal:this.abort.signal};this.reduce=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduce.matches;this.duration=Number(this.dataset.duration)||5000;this.button=this.querySelector('[data-pause]');this.querySelector('[data-next]')?.addEventListener('click',()=>this.show(this.index+1),opt);this.querySelector('[data-previous]')?.addEventListener('click',()=>this.show(this.index-1),opt);this.button?.addEventListener('click',()=>{this.paused=!this.paused;this.sync()},opt);this.reduce.addEventListener('change',()=>{this.paused=this.reduce.matches;this.sync()},opt);document.addEventListener('visibilitychange',()=>this.sync(),opt);this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.block===e.detail.blockId);if(i>=0){this.paused=true;this.show(i)}},opt);this.viewport=matchMedia('(max-width:799px)');this.viewport.addEventListener('change',()=>this.selectVideo(),opt);this.selectVideo();this.prepare(1);this.sync()}
selectVideo(){const slot=this.querySelector('.wv-launch__video-slot');const source=this.viewport.matches&&this.dataset.mobileMedia==='images'?null:this.querySelector(this.viewport.matches?'[data-video-mobile]':'[data-video-desktop]');slot.querySelector('video')?.pause();slot.replaceChildren();this.video=null;if(source){slot.append(source.content.cloneNode(true));this.video=slot.querySelector('video');this.video.muted=true}slot.hidden=!this.video;this.classList.toggle('has-video',!!this.video);this.sync()}
disconnectedCallback(){this.video?.pause();clearTimeout(this.timer);this.request=(this.request||0)+1;this.slides.forEach(s=>clearTimeout(s.leaveTimer));this.abort?.abort()}
prepare(i){const image=this.slides[i%this.slides.length]?.querySelector('img');if(!image)return Promise.resolve();image.loading='eager';return image.decode?image.decode().catch(()=>{}):Promise.resolve()}
async show(i){if(!this.slides.length)return;clearTimeout(this.timer);const request=this.request=(this.request||0)+1;const next=(i+this.slides.length)%this.slides.length;await this.prepare(next);if(request!==this.request||!this.isConnected)return;const previous=this.slides[this.index];if(next!==this.index){previous.classList.add('is-leaving');clearTimeout(previous.leaveTimer);previous.leaveTimer=setTimeout(()=>previous.classList.remove('is-leaving'),750)}this.index=next;this.slides.forEach((s,n)=>{if(n===next){clearTimeout(s.leaveTimer);s.classList.remove('is-leaving')}s.classList.toggle('is-active',n===next);s.setAttribute('aria-hidden',String(n!==next))});this.prepare((next+1)%this.slides.length);this.sync()}
sync(){clearTimeout(this.timer);if(this.video){if(this.paused||document.hidden)this.video.pause();else this.video.play().catch(()=>{});return;}this.classList.toggle('is-paused',this.paused||document.hidden);this.classList.toggle('is-reduced',this.reduce.matches);if(this.button)this.button.textContent=this.paused?this.button.dataset.play:this.button.dataset.stop;if(!this.paused&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>this.show(this.index+1),this.duration)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-coat-installation"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('woodvibe-coat-installation')){
 customElements.define('woodvibe-coat-installation',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;this.abort=new AbortController();
   this.querySelectorAll('[data-steps]').forEach(gallery=>{
    if(!gallery.querySelector('[data-install-step]')||gallery.querySelector('.shelf-step-hint'))return;
    const hint=document.createElement('p');hint.className='shelf-step-hint';hint.textContent=this.dataset.slideHint;
    gallery.prepend(hint);
    const next=gallery.querySelector('[data-step-next]');next.textContent=this.dataset.nextLabel+' →';
   });
   this.initGroups();
   this.listen(this,'click',e=>{const b=e.target.closest('button');if(!b||!this.contains(b))return;
    if(b.hasAttribute('data-step-prev'))this.stepMove(b.closest('[data-steps]'),-1);
    if(b.hasAttribute('data-step-next'))this.stepMove(b.closest('[data-steps]'),1);
    if(b.hasAttribute('data-zoom')){this.$('[data-zoom-content]').replaceChildren(b.firstElementChild.cloneNode(true));this.$('.wm-zoom-dialog').showModal();}
    if(b.hasAttribute('data-close-zoom'))this.$('.wm-zoom-dialog').close();
    if(b.dataset.fixTab)this.selectGroup(b.dataset.fixTab);
    if(b.dataset.finish){this.querySelectorAll('[data-finish]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));this.querySelectorAll('[data-finish-panel]').forEach(x=>x.hidden=x.dataset.finishPanel!==b.dataset.finish);}
   });
   this.querySelectorAll('[data-steps]').forEach(gallery=>{const rail=gallery.querySelector('[data-step-rail]');this.listen(rail,'scroll',()=>this.stepPosition(gallery));this.listen(rail,'keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.stepMove(gallery,e.key==='ArrowRight'?1:-1);}});this.stepPosition(gallery);});
   this.resize=new ResizeObserver(()=>this.querySelectorAll('[data-steps]').forEach(g=>this.stepPosition(g)));this.querySelectorAll('[data-step-rail]').forEach(rail=>this.resize.observe(rail));
   this.listen(document,'shopify:block:select',e=>{
    if(!this.contains(e.target))return;
    const panel=e.target.closest('[data-fix-panel]');if(!panel)return;
    this.selectGroup(panel.dataset.fixPanel);
    requestAnimationFrame(()=>e.target.closest('.wm-step')?.scrollIntoView({block:'nearest',inline:'start',behavior:'instant'}));
   });
  }
  disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();this.$('dialog')?.close();this.ready=false;}

  initGroups(){
   const panels=[...this.querySelectorAll('[data-fix-panel]')];
   const enabled=panels.filter(p=>p.dataset.enabled==='true');
   // Theme blocks supply their actual IDs and titles through their rendered markup.
   this.$('[data-install-tabs]').replaceChildren(...enabled.map(panel=>{
    const button=document.createElement('button');button.type='button';
    button.dataset.fixTab=panel.dataset.fixPanel;
    button.setAttribute('aria-controls',panel.id);
    button.setAttribute('aria-pressed','false');
    button.textContent=panel.dataset.tabTitle;
    return button;
   }));
   this.dataset.snapEnabled=String(enabled.some(p=>p.dataset.support==='snap'));
   this.querySelectorAll('[data-finish-copy]').forEach(copy=>{
    copy.hidden=(copy.dataset.finishCopy==='snap')!==(this.dataset.snapEnabled==='true');
   });
   this.querySelectorAll('[data-steps]').forEach(g=>{
    const cards=[...g.querySelectorAll('[data-install-step]')];
    cards.forEach((c,i)=>c.querySelector('[data-step-number]').textContent=i+1);
    g.hidden=!cards.length;
   });
   this.selectGroup(this.querySelector('[data-fix-tab]')?.dataset.fixTab);
   queueMicrotask(()=>document.dispatchEvent(new CustomEvent('woodvibe:snap-visibility-change')));
  }
  selectGroup(id){
   this.querySelectorAll('[data-fix-tab]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.fixTab===id)));
   this.querySelectorAll('[data-fix-panel]').forEach(p=>{p.hidden=p.dataset.fixPanel!==id;if(p.hidden){p.querySelectorAll('video').forEach(v=>v.pause());p.querySelectorAll('wv-togglezip-video details[open]').forEach(d=>d.open=false);}});
   requestAnimationFrame(()=>this.querySelectorAll('[data-steps]').forEach(g=>this.stepPosition(g)));
  }
  listen(target,name,fn){target?.addEventListener(name,fn,{signal:this.abort.signal});}
  $(s){return this.querySelector(s);}
    stepPosition(gallery) {
      const rail=gallery.querySelector('[data-step-rail]'),cards=[...rail.children];if(!cards.length||!rail.clientWidth)return;
      const left=rail.getBoundingClientRect().left,right=left+rail.clientWidth;
      const visible=cards.map((c,i)=>({i,r:c.getBoundingClientRect()})).filter(x=>Math.min(x.r.right,right)-Math.max(x.r.left,left)>=Math.min(x.r.width,rail.clientWidth)*.5);
      if(!visible.length)return;
      gallery.querySelector('[data-step-counter]').textContent=`${gallery.dataset.stepLabel} ${visible[0].i+1}${visible.length>1?'–'+(visible.at(-1).i+1):''} / ${cards.length}`;
      gallery.querySelector('[data-step-prev]').disabled=rail.scrollLeft<2;
      gallery.querySelector('[data-step-next]').disabled=rail.scrollLeft+rail.clientWidth>=rail.scrollWidth-2;
    }
    stepMove(gallery,delta) {
      const rail=gallery.querySelector('[data-step-rail]'),card=rail.firstElementChild;
      if(!card)return;
      const gap=parseFloat(getComputedStyle(rail).gap)||0;
      rail.scrollBy({left:delta*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
    }
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-coat-racks"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wv-coat-racks')) {
  customElements.define('wv-coat-racks', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.videoPanels = Array.from(this.querySelectorAll('[data-gallery-video]'));
      this.videoItems = this.videoPanels.map(panel => ({type:'video', id:panel.dataset.galleryVideo, model:panel.dataset.model, color:panel.dataset.color, title:panel.dataset.title, url:panel.dataset.poster, width:320, height:320}));
      this.videoObserver = new IntersectionObserver(() => this.syncVideos(), {threshold:[0,0.15]});
      this.videoPanels.forEach(panel => this.videoObserver.observe(panel));
      this.onPageHidden = () => this.syncVideos();
      document.addEventListener('visibilitychange', this.onPageHidden);
      this.items = JSON.parse(this.querySelector('[data-images]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.prices = JSON.parse(this.querySelector('[data-prices]').textContent);
      const params = new URLSearchParams(location.search);
      this.model = this.dataset.initialModel || 'x3';
      if (this.dataset.productPage !== 'true' && ['x1','x3','x5'].includes(params.get('coat_model'))) this.model = params.get('coat_model');
      this.color = 'vert-olive'; this.active = 0;
      this.variants = JSON.parse(this.querySelector('[data-coat-variants]')?.textContent || '[]');
      const selected = this.variants.find(v=>String(v.id)===params.get('variant'));
      if(selected)this.color=selected.option1.toLowerCase().replaceAll(' ','-');
      this.querySelectorAll('.wv-coat__models input,.wv-coat__colors input').forEach(input=>{input.checked=input.value===this.model||input.value===this.color;});
      this.scenes = this.items.filter(item => item.placement === 'scene' || (item.series === 'v09' && item.view === '03-trois-quarts-droit' && item.placement !== 'collection'));
      this.sceneIndex = 0;
      this.dialog = this.querySelector('dialog');
      this.querySelectorAll('input[type=radio]').forEach(input => input.addEventListener('change', () => {
        if (input.name.includes('coat-mount')) return;
        if (input.name.includes('coat-model')) {
          if(this.dataset.productPage==='true'){
            const handles={x1:'pateres-snap-lot-de-3',x3:'porte-manteau-snap-3-crochets',x5:'porte-manteau-snap-5-crochets'};
            location.href='/products/'+handles[input.value]; return;
          }
          this.model = input.value;
        }
        else if (input.name.includes('coat-color')) this.color = input.value;
        this.active = 0;
        this.renderProduct();
      }));
      this.querySelector('[data-main-zoom]').addEventListener('click', () => this.openPhoto('product'));
      this.querySelector('[data-scene-zoom]').addEventListener('click', () => this.openPhoto('scene'));
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => this.opener?.focus({ preventScroll: true }));
      this.querySelector('[data-previous]').addEventListener('click', () => this.moveDialog(-1));
      this.querySelector('[data-next]').addEventListener('click', () => this.moveDialog(1));
      this.dialog.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); this.moveDialog(e.key === 'ArrowLeft' ? -1 : 1); }
      });
      this.querySelector('[data-choose-scene]').addEventListener('click', () => {
        const scene = this.scenes[this.sceneIndex];
        if(this.dataset.productPage==='true' && scene.model!==this.model){
          const handles={x1:'pateres-snap-lot-de-3',x3:'porte-manteau-snap-3-crochets',x5:'porte-manteau-snap-5-crochets'};
          location.href='/products/'+handles[scene.model];return;
        }
        this.model = scene.model; this.color = scene.color; this.active = 0;
        this.querySelectorAll('.wv-coat__models input,.wv-coat__colors input').forEach(input => { input.checked = input.value === this.model || input.value === this.color; });
        this.renderProduct();
        this.querySelector('.wv-coat__hero').scrollIntoView({ behavior: 'auto', block: 'start' });
        this.querySelector('input[name*=coat-model]:checked').focus({ preventScroll: true });
      });
      this.bindSwipe(this.querySelector('[data-main-zoom]'), direction => { this.active = (this.active + direction + this.gallery.length) % this.gallery.length; this.showProductPhoto(); });
      this.bindSwipe(this.querySelector('[data-scene-zoom]'), direction => { this.sceneIndex = (this.sceneIndex + direction + this.scenes.length) % this.scenes.length; this.showScene(); });
      this.querySelectorAll('[data-coat-detail-zoom]').forEach(button=>button.addEventListener('click',()=>{
        this.active=this.gallery.findIndex(i=>i.view===button.dataset.coatDetailZoom);
        this.showProductPhoto();this.openPhoto('product');this.opener=button;
      }));
      this.renderProduct(); this.renderScenes();
    }
    disconnectedCallback() {
      this.pauseVideos(); this.videoObserver?.disconnect();
      document.removeEventListener('visibilitychange', this.onPageHidden);
    }
    syncVideos() {
      this.videoPanels?.forEach(panel => {
        const video=panel.querySelector('video'); if(!video)return;
        const rect=panel.getBoundingClientRect();
        const visibleHeight=Math.min(rect.bottom,innerHeight)-Math.max(rect.top,0);
        if(!panel.hidden&&!document.hidden&&visibleHeight>Math.min(rect.height,innerHeight)*0.15){
          video.muted=true; video.loop=true;
          const promise=video.play();
          if(promise)promise.then(()=>{if(panel.hidden||document.hidden)video.pause();}).catch(error=>{
            if(error.name!=='AbortError'&&!panel.hidden)video.controls=true;
          });
        }else video.pause();
      });
    }
    pauseVideos() { this.videoPanels?.forEach(panel => panel.querySelector('video')?.pause()); }
    imageUrl(item, width) {
      const url = new URL(item.url, location.href); url.searchParams.set('width', width); return url.href;
    }
    colorLabel(color) { return this.labels[color.replaceAll('-', '_')]; }
    viewLabel(item) {
      if (item.type === 'video') return item.title || 'Voir la vidéo';
      if (item.view === 'packshot') return 'Vue sur fond blanc';
      const names = {'02-face':'face','03-trois-quarts-droit':'right','04-trois-quarts-gauche':'left','05-zoom':'zoom'};
      return this.labels[names[item.view]] || this.labels.scene_caption;
    }
    modelLabel(item) { return this.labels[item.model] + ' · ' + (item.model === 'x1' ? this.labels.x1_short : item.model === 'x3' ? '40 cm' : '72 cm'); }
    sceneTitle(item) { return this.modelLabel(item) + ' · ' + this.colorLabel(item.color); }
    updatePhotoCopy(frame, item) {
      if (!frame) return;
      const detail = item.view === '05-zoom';
      const kind = detail ? 'detail' : frame.hasAttribute('data-scene-zoom') ? 'scene' : item.view === 'lifestyle-2' ? 'daily' : item.view === 'lifestyle-3' ? 'palette' : item.model;
      const title = frame.querySelector('[data-photo-title]');
      const text = frame.querySelector('[data-photo-text]');
      const label = frame.querySelector('[data-photo-label]');
      if (title) title.textContent = this.labels['visual_' + kind + '_title'];
      if (text) text.textContent = this.labels['visual_' + kind + '_text'];
      if (label) label.textContent = this.sceneTitle(item);
      frame.dataset.photoKind = kind;
    }
    alt(item) { if(item.alt)return item.alt; return item.series === 'v09' ? this.sceneTitle(item) + '. ' + this.labels.scene_caption : this.labels[item.model] + ' · ' + this.colorLabel(item.color) + ' · ' + this.viewLabel(item); }
    setImage(img, item, large=false) {
      img.srcset = [400,640,800,1200,1600].filter(w => w <= item.width).map(w => this.imageUrl(item,w)+' '+w+'w').join(', ');
      img.sizes = large ? '92vw' : '(min-width: 1440px) 700px, (min-width: 750px) 52vw, calc(100vw - 32px)';
      img.src = this.imageUrl(item, large ? item.width : 1000);
      img.style.objectFit = item.view === 'packshot' ? 'contain' : ''; 
      img.alt = this.alt(item); img.width = item.width; img.height = item.height;
      const frame=img.closest('.wv-coat__photo');
      if(frame){frame.style.aspectRatio=frame.hasAttribute('data-main-zoom')?'auto':item.width+'/'+item.height;img.style.aspectRatio=frame.hasAttribute('data-main-zoom')?item.width+'/'+item.height:'auto';this.updatePhotoCopy(frame,item);}
    }
    makeThumb(item, index, callback, scene=false) {
      const button = document.createElement('button'); button.type = 'button'; button.dataset.index = index;
      button.setAttribute('aria-label', scene ? this.sceneTitle(item) : this.viewLabel(item));
      button.setAttribute('aria-pressed','false');
      const img = document.createElement('img'); img.src = this.imageUrl(item,200); img.alt = ''; img.loading = 'lazy'; img.width = item.width; img.height = item.height;
      button.append(img);
      if(item.type==='video'){
        button.dataset.videoThumb='true';
        const icon=document.createElement('span');icon.className='wv-coat__video-icon';icon.setAttribute('aria-hidden','true');
        const symbol=document.createElement('span');symbol.textContent='Vidéo';icon.append(symbol);button.append(icon);
      }
      button.addEventListener('click', () => callback(index)); return button;
    }
    renderProduct() {
      this.gallery = this.items.filter(item => item.model === this.model && item.color === this.color && item.placement !== 'collection' && !this.scenes.includes(item));
      const matchingVideos=this.videoItems.filter(item=>item.model===this.model&&item.color===this.color);
      this.gallery.splice(1,0,...(matchingVideos.length?matchingVideos:this.videoItems.filter(item=>item.model===this.model&&item.color==='all')));
      const thumbs = this.querySelector('[data-thumbnails]');
      thumbs.replaceChildren(...this.gallery.map((item,index) => this.makeThumb(item,index,i => { this.active=i; this.showProductPhoto(); })));
      this.querySelector('[data-color-name]').textContent=this.colorLabel(this.color);
      this.querySelector('[data-product-title]').textContent=this.labels[this.model+'_product_title'];
      this.querySelector('[data-product-price]').textContent=this.prices[this.model];
      const variant=this.variants.find(v=>v.option1.toLowerCase().replaceAll(' ','-')===this.color);
      if(variant){
        this.querySelector('[data-coat-variant]').value=variant.id;
        this.querySelector('[data-coat-buy]').disabled=!variant.available;
        this.querySelector('[data-coat-buy-label]').textContent=variant.available?this.labels.add_to_cart:this.labels.unavailable;
        this.querySelector('[data-product-price]').textContent=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:'EUR'}).format(variant.price/100);
      }
      this.querySelectorAll('[data-kit-model]').forEach(el=>{el.hidden=el.dataset.kitModel!==this.model;});
      this.querySelectorAll('[data-color-image]').forEach(img=>{const item=this.items.find(item=>item.model===this.model && item.color===img.dataset.colorImage && item.view==='05-zoom');if(item)img.src=this.imageUrl(item,160);});
      this.querySelectorAll('[data-model-image]').forEach(img=>{
        const model=img.dataset.modelImage;
        const item=this.items.find(i=>i.model===model && i.color===this.color && i.view===(model==='x1'?'05-zoom':'02-face'));
        if(item){img.src=this.imageUrl(item,320);img.srcset=this.imageUrl(item,160)+' 160w, '+this.imageUrl(item,320)+' 320w';img.sizes='(min-width: 750px) 160px, 30vw';}
      });
      this.querySelector('[data-model-description]').textContent=this.labels[this.model+'_desc'];
      this.querySelector('[data-included]').textContent=this.labels[this.model+'_included'];
      this.querySelector('[data-single-note]').hidden=this.model!=='x1';
      this.querySelectorAll('[data-coat-detail]').forEach(img=>{
        const item=this.items.find(i=>i.model===this.model&&i.color===this.color&&i.view===img.dataset.coatDetail);
        if(item)this.setImage(img,item);
      });
      this.showProductPhoto();
      const match=this.scenes.findIndex(item => item.model===this.model && item.color===this.color);
      if(match>=0){this.sceneIndex=match;this.showScene();}
    }
    showProductPhoto() {
      const main = this.querySelector('[data-main-zoom]');
      const item=this.gallery[this.active];
      this.pauseVideos();
      const isVideo=item?.type==='video';
      main.hidden=isVideo;
      this.videoPanels.forEach(panel=>{panel.hidden=!isVideo||panel.dataset.galleryVideo!==item.id;});
      this.querySelectorAll('[data-thumbnails] button').forEach((button,index)=>button.setAttribute('aria-pressed',String(index===this.active)));
      if(isVideo){this.syncVideos();return;}
      const origin = main.querySelector('[data-photo-origin]');
      if (origin) origin.hidden = this.active !== 0;
      main.querySelector('[data-photo-label]').hidden = this.active === 0;
      this.setImage(this.querySelector('[data-main-image]'),this.gallery[this.active]);
      this.querySelectorAll('[data-thumbnails] button').forEach((button,index)=>button.setAttribute('aria-pressed',String(index===this.active)));
    }
    renderScenes() {
      this.querySelector('[data-scene-thumbnails]').replaceChildren(...this.scenes.map((item,index)=>this.makeThumb(item,index,i=>{this.sceneIndex=i;this.showScene();},true)));
      this.showScene();
    }
    showScene() {
      const item=this.scenes[this.sceneIndex];
      this.setImage(this.querySelector('[data-scene-image]'),item);
      this.querySelector('[data-scene-title]').textContent=this.sceneTitle(item);
      this.querySelectorAll('[data-scene-thumbnails] button').forEach((button,index)=>button.setAttribute('aria-pressed',String(index===this.sceneIndex)));
    }
    openPhoto(source) {
      if(this.swiped){this.swiped=false;return;}
      this.source=source;this.opener=source==='product'?this.querySelector('[data-main-zoom]'):this.querySelector('[data-scene-zoom]');
      this.updateDialog();this.dialog.showModal();this.querySelector('[data-close]').focus();
    }
    updateDialog() {
      const item=this.source==='product'?this.gallery[this.active]:this.scenes[this.sceneIndex];
      this.setImage(this.querySelector('[data-dialog-image]'),item,true);this.querySelector('[data-dialog-caption]').textContent=this.alt(item);
    }
    moveDialog(direction) {
      if(this.source==='product'){do{this.active=(this.active+direction+this.gallery.length)%this.gallery.length;}while(this.gallery[this.active].type==='video');this.showProductPhoto();}
      else{this.sceneIndex=(this.sceneIndex+direction+this.scenes.length)%this.scenes.length;this.showScene();}
      this.updateDialog();
    }
    bindSwipe(element,callback) {
      let start=null;
      element.addEventListener('touchstart',e=>{const t=e.touches[0];start={x:t.clientX,y:t.clientY};this.swiped=false;},{passive:true});
      element.addEventListener('touchend',e=>{if(!start)return;const t=e.changedTouches[0],dx=t.clientX-start.x,dy=t.clientY-start.y;start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){this.swiped=true;callback(dx<0?1:-1);setTimeout(()=>{this.swiped=false;},350);}},{passive:true});
      element.addEventListener('touchcancel',()=>{start=null;},{passive:true});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wv-new-accessories"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('wv-products-strip'))customElements.define('wv-products-strip',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();const opt={signal:this.abort.signal};this.track=this.querySelector('.wv-new__track');this.originals=[...this.track.children];if(!this.originals.length)return;this.reduced=matchMedia('(prefers-reduced-motion: reduce)');this.paused=this.reduced.matches;this.hover=false;this.focus=false;this.speed=Number(this.dataset.speed)||22;this.button=this.closest('section').querySelector('[data-pause]');this.button.addEventListener('click',()=>{this.paused=!this.paused;this.button.textContent=this.paused?'▶':'Ⅱ'},opt);this.track.addEventListener('pointerenter',()=>this.hover=true,opt);this.track.addEventListener('pointerleave',()=>this.hover=false,opt);this.track.addEventListener('focusin',()=>this.focus=true,opt);this.track.addEventListener('focusout',e=>this.focus=this.track.contains(e.relatedTarget),opt);this.track.addEventListener('touchstart',()=>{this.paused=true;this.button.textContent='▶'},opt);this.reduced.addEventListener('change',()=>{this.paused=this.reduced.matches;this.button.textContent=this.paused?'▶':'Ⅱ'},opt);this.closest('section').querySelectorAll('[data-step]').forEach(b=>b.addEventListener('click',()=>{this.paused=true;this.button.textContent='▶';this.track.scrollLeft+=Number(b.dataset.step)*(this.originals[0].getBoundingClientRect().width+(parseFloat(getComputedStyle(this.track).columnGap)||0))},opt));this.resize=new ResizeObserver(()=>this.build());this.resize.observe(this);this.build();this.tick=time=>{const dt=Math.min((time-(this.last||time))/1000,.05);this.last=time;if(!this.paused&&!this.hover&&!this.focus&&!document.hidden&&this.period){this.track.scrollLeft-=this.speed*dt;if(this.track.scrollLeft<this.period)this.track.scrollLeft+=this.period;if(this.track.scrollLeft>this.period*2)this.track.scrollLeft-=this.period}this.frame=requestAnimationFrame(this.tick)};this.frame=requestAnimationFrame(this.tick)}
build(){this.track.querySelectorAll('[data-clone]').forEach(x=>x.remove());const gap=parseFloat(getComputedStyle(this.track).columnGap)||0;this.period=this.originals.reduce((n,x)=>n+x.getBoundingClientRect().width+gap,0);if(!this.period)return;const copies=Math.ceil(this.track.clientWidth/this.period)+3;for(let i=0;i<copies;i++)this.originals.forEach(x=>{const c=x.cloneNode(true);c.dataset.clone='true';c.removeAttribute('data-shopify-editor-block');c.setAttribute('aria-hidden','true');c.querySelectorAll('a,button').forEach(a=>a.tabIndex=-1);this.track.append(c)});this.track.scrollLeft=this.period;this.button.textContent=this.paused?'▶':'Ⅱ'}
disconnectedCallback(){cancelAnimationFrame(this.frame);this.resize?.disconnect();this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();
})();
